function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "drop-down-arrow");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-419.000000, -802.000000)",
  fill: "#9B9B9B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "section-filtros",
  transform: "translate(273.000000, 709.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "drop-down-arrow",
  transform: "translate(153.500000, 98.387255) scale(1, -1) translate(-153.500000, -98.387255) translate(146.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.816201,0.190735294 C14.5711275,-0.0555882353 14.1735049,-0.0555882353 13.9284314,0.190735294 L7.50034314,7.24406863 L1.07159314,0.190735294 C0.826519608,-0.0555882353 0.428872549,-0.0555882353 0.18379902,0.190735294 C-0.0612745098,0.437058824 -0.0612745098,0.836568627 0.18379902,1.08286765 L7.02455882,8.58877451 C7.15522059,8.72007353 7.32901961,8.77632353 7.49970588,8.76759804 C7.67098039,8.77632353 7.84419118,8.72007353 7.97485294,8.58877451 L14.8162255,1.08220588 C15.0612745,0.835931373 15.0612745,0.437058824 14.816201,0.190735294 Z",
  id: "Path"
})))));

var SvgDropDownArrow = function SvgDropDownArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    viewBox: "0 0 15 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropDownArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drop-down-arrow.d27b2158.svg";
export { ForwardRef as ReactComponent };